import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'
import { Funcionario } from './funcionario'
import { TabelaHorarioFuncionario, TabelaHorarios } from './tabela-horarios'

export type TrocaDiaTrabalho = z.infer<typeof zod.TrocaDiaTrabalhoSchema> & {
    Funcionario?: Funcionario
    TabelaHorario?: TabelaHorarios
}

export const CreateTrocaAutomaticaTabelaSchema =
    zod.TrocaTabelaAutomaticaSchema.omit({
        createdAt: true,
        updatedAt: true,
        id: true,
        repeticaoMensalOpcao: true,
        tipoRepeticao: true,
        every: true,
        tabelaHorarioId: true,
        funcionarioId: true,
        clienteId: true,
        empresaId: true,
        tipoDuracaoRepeticao: true,
    })
        .extend({
            tipoRepeticao: z.enum(['DIARIO', 'SEMANAL', 'MENSAL']),
            tipoDuracaoRepeticao: z.enum(['DIARIO', 'SEMANAL', 'MENSAL']),
            repeticaoMensalOpcao: z.enum(['DIA', 'SEMANA']),
            every: z.coerce.number().int().min(0).max(999).default(1),
            tabelaHorarioId: z.coerce
                .number({ message: 'Obrigatório' })
                .int({ message: 'Obrigatório' })
                .positive({ message: 'Obrigatório' }),
        })
        .refine(
            ({
                every,
                tipoRepeticao,
                duracaoRepeticao,
                tipoDuracaoRepeticao,
            }) => {
                function getDays() {
                    switch (tipoDuracaoRepeticao) {
                        case 'DIARIO':
                            return duracaoRepeticao
                        case 'SEMANAL':
                            return duracaoRepeticao * 7
                        case 'MENSAL':
                            return duracaoRepeticao * 31
                        default:
                            return duracaoRepeticao
                    }
                }

                switch (tipoRepeticao) {
                    case 'DIARIO':
                        return every > 0 && every + 1 > getDays()
                    case 'SEMANAL':
                        return (
                            every >= 0 && every + 1 > Math.floor(getDays() / 7)
                        )
                    case 'MENSAL':
                        return (
                            every >= 0 && every + 1 > Math.floor(getDays() / 31)
                        )
                    default:
                        return true
                }
            },
            {
                message:
                    'A duração não pode superar a repetição, utilize um valor menor ou um intervalo maior',
                path: ['duracaoRepeticao'],
            },
        )

export type TrocaAutomaticaTabela = z.infer<
    typeof zod.TrocaTabelaAutomaticaSchema
> & {
    TabelaHorario?: TabelaHorarios
    Funcionario?: Funcionario
}

const service = new ApiService<TabelaHorarioFuncionario>('troca-horarios')

const trocaDiaTrabalho = new ApiService<TrocaDiaTrabalho>(
    'troca-horarios/dia-trabalho',
)

const trocaAutomatica = new ApiService<TrocaAutomaticaTabela>(
    'troca-horario-automatica',
)

export const trocaHorario = Object.assign(service, {
    diaTrabalho: trocaDiaTrabalho,
    trocaAutomatica,
})
